/* eslint-disable no-useless-escape */
import { Modal, ModalBody } from "react-bootstrap";
import { popCancelBttn, imsLoader } from "../../assets";
import { Component } from "react";
import Button from "../Button";
import './GlobalSearchFeaturesPopUp.css'
import './BookmarkPopUp.css'
import ApiServices from "../../utils/apiServices";
import { LocationOrigin, getCurrentDate, snippetLongString } from "../../utils/utilityServices"
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { Authentication } from "../../utils/authenticationUtilityServices";

let _locationOrigin = LocationOrigin;
//_locationOrigin = 'https://predev-ims.jnj.com';
class SharePubMedModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiResponse: [],
      shared_to_email: '',
      error: '',
      confirmMessageContent: '',
      confirmMessageShowModal: false,
      confirmMessageIndex: -1,
      login_id: 0,
      prompt: '',
      template_name: '',
      alertMessageShowModal: false,
      alertMessageContent: '',
      alertMessageModelColor: "",
      formIsValid: true,
      isLoading: false
    };
  }
  // async componentDidMount() {
  //   this.setState({
  //     login_id: this.props.selectedPrompt?.[0]?.login_id,
  //     prompt: this.props.selectedPrompt?.[0]?.prompt,
  //     template_name: this.props.selectedPrompt?.[0]?.template_name
  //   })
  // }

  showConfirmMessage = (message, index) => {
    this.setState({
      confirmMessageContent: message,
      confirmMessageShowModal: true,
      confirmMessageIndex: index
    })
  }

  handleInput = (e) => {
    e.target.value = snippetLongString(e.target.value);
    this.setState({
      shared_to_email: e.target.value
    })
  }
  handleValidation = async () => {
    let errors = {};
    let form_Is_Valid = true;
    let service = new ApiServices();
    let sharedEmail = this.state.shared_to_email?.toLowerCase().trim();
    let username = JSON.parse(localStorage.getItem('username'));
    if (username) {
      username = username.toLowerCase();
    }
    let apiRes = await service.getUserDetailsByUserName(sharedEmail);    
    if (sharedEmail?.length === 0) {
      form_Is_Valid = false;
      errors["proptError"] = 'Please enter a valid email to proceed.';
    }
    else if (username?.toLowerCase() === sharedEmail?.toLowerCase()) {
      form_Is_Valid = false;
      errors["proptError"] = "Please use an email address other than yours's to share."
    }
    else if(sharedEmail.split('jnj.com').length > 2){
      form_Is_Valid = false;
      errors["proptError"] = "Please use only one user email address at a time."
    }
    else if (apiRes?.length === 0) {
      form_Is_Valid = false;
      errors["proptError"] = 'Email is not a registered mail.Please enter a registerd email.'
    }
    else if (!sharedEmail.includes('@its.jnj.com')) {
      form_Is_Valid = false;
      errors["proptError"] = `Email id must contain domain name ex: user@its.jnj.com`;
    }
    this.setState({ error: errors, formIsValid: form_Is_Valid });
    return {apiRes, form_Is_Valid};
  }

  errorAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#de1327",
      alertMessageShowModal: true
    })
  }

  successAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#2eb000",
      alertMessageShowModal: true
    })
  }

  generateDownloadTimestamp = () => {
    const now = new Date()
    return now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + "_" + now.getHours() + "-" + now.getMinutes() + "-" + now.getSeconds()
  }

  handleSubmit = async () => {    
    try {
      let service = new ApiServices();
      this.setState({isLoading: true})
      const {apiRes, form_Is_Valid} = await this.handleValidation()
      if (form_Is_Valid) {
        if (this.props.shareFrom.fromSaveSearch) {            
            const {savesearch_id, query, filters, savesearch_name, doc_id} = this.props.saveSearchItem
            const email = apiRes?.[0].email
            const user_id = email.split("@")[0]
            const search_id = savesearch_id
            
            const data =  {
              user_id,
              search_id: doc_id          
            }
            //first
            const url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}search/save/copy`     
               const _headers = {
                  'Content-Type': 'application/json'
                };
                if (await Authentication.isAccessTokenAvailable()) {
                  // No Authorization header provided, attach the default one
                  const token = await Authentication.getAccessToken();
                  _headers.Authorization = `Bearer ${token}`;
                }    
            const res = await axios.post(url, data, {
              headers: _headers       
            })
            //console.log({data: res.data})
            if (res.data?.elastic_bulk_insert_response?.errors) {
              this.errorAlertMessage("Something Went Wrong. Kindly try after some time.");                    
            } else {
              //second
              const newSaveSearchId = `SS_${uuidv4()}`;
              const newSaveSearchName = savesearch_name + '_' + this.generateDownloadTimestamp()
              let wwid = JSON.parse(localStorage.getItem('wwid'));
              let shared_from_email = JSON.parse(localStorage.getItem('username'));
              let shared_from_name = JSON.parse(localStorage.getItem('userdisplayName'));
              const userObj = {
                loginid: email, 
                sharedFromLoginId : wwid, 
                sharedFromEmail: shared_from_email, 
                sharedFromName: shared_from_name, 
                newSaveSearchId, 
                newSaveSearchName,              
                oldSaveSearchId: search_id
              }            
              await service.sharePubmedSaveSearch(userObj);
                          
              //third
              const userObj1 = {
                  newSaveSearchId,
                  oldSaveSearchId: search_id,                  
              } 
              await service.sharePubmedSaveSearchDocids(userObj1);              
              this.successAlertMessage("The Saved search shared successfully.")             
            }
        } else if(this.props.shareFrom.fromReviewList) {
            this.setState({isLoading: true})
            const sharedReviewListUsername = apiRes?.[0].email
            const sharedReviewListUserid = sharedReviewListUsername.split("@")[0]
            const {reviewlist_id:reviewListId, reviewlist_name} = this.props.shareReviewList
            const sharedReviewListId = `RL_${uuidv4()}`;
            const sharedReviewListName = reviewlist_name + '_' + this.generateDownloadTimestamp()
            const lastCreatedDatehour = getCurrentDate()
            
            const data =  {
              reviewListId,
              sharedReviewListId,
              sharedReviewListName,
              sharedReviewListUsername,
              sharedReviewListUserid,
              lastCreatedDatehour
            }
            //first
            const url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}reviewlist/sprld`      
                const _headers = {
                  'Content-Type': 'application/json'
                };
                if (await Authentication.isAccessTokenAvailable()) {
                  // No Authorization header provided, attach the default one
                  const token = await Authentication.getAccessToken();
                  _headers.Authorization = `Bearer ${token}`;
                }  
            const res = await axios.post(url, data, {
              headers: _headers         
            })
            if (res.data?.errors) {
              this.errorAlertMessage("Something Went Wrong. Kindly try after some time.");                    
            } else {
              //second
              let wwid = JSON.parse(localStorage.getItem('wwid'));
              let shared_from_email = JSON.parse(localStorage.getItem('username'));
              let shared_from_name = JSON.parse(localStorage.getItem('userdisplayName'));
              const userObj = {
                loginid: sharedReviewListUsername, 
                newReviewListId: sharedReviewListId, 
                newReviewlistName: sharedReviewListName,
                sharedFromLoginId : wwid, 
                sharedFromEmail: shared_from_email, 
                sharedFromName: shared_from_name, 
                oldReviewListId: reviewListId
              }
              await service.sharePubMedReviewList(userObj);
                          
              //third
              const userObj1 = {
                  newReviewList: sharedReviewListId,
                  oldReviewListId: reviewListId
              } 
              await service.sharePubMedReviewListDocids(userObj1);            
              this.successAlertMessage("Review List shared successfully") 
            }
        } else {

        }           
      }
    } catch(err) {
      console.log({err})
      this.errorAlertMessage("Something Went Wrong. Kindly try after some time.");      
    } finally {
      this.setState({isLoading: false})
    }        
  }

  closeAlertMessage = () => {
    this.setState({ showPop: false, alertMessageShowModal: false });
    this.props.handleClose(false);
  }

  render() {    
    const { isLoading, alertMessageContent, 
      alertMessageModelColor, alertMessageShowModal } = this.state;
    
    return (        
          <Modal
            show={this.props.showModal}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            className="z-index-Share"
            backdropClassName="z-index-Share-backdrop"
            scrollable={true}
          >
            <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
              <div className="popup-cancel-btn-wrapper">
                <img
                  src={popCancelBttn}
                  alt=""
                  onClick={e => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }}
                />
              </div>
              <div>
                <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left" }}>
                </Modal.Header>
                <Modal.Body scrollable={true} style={{ maxHeight: "40vh", padding: " 1rem 3rem" }}>
                  <div>
                    <span className="create-bookmark-field">
                      Enter the email address of the user you would like to share this {this.props.shareFrom.fromSaveSearch ? "Saved Search:" : "Review List:"}  ​</span>
                    <br />
                    <input type="text" placeholder="ex: user@its.jnj.com​" value={this.state.bookmarkName} className="create-bookmark-input-box" onChange={this.handleInput}  /*onBlur={this.handleValidation}*/
                    />
                    <br />
                    {/*<span className="length-info">Name with a maximum of 100 characters.</span>*/}
                    <div className="errorInvalidName">{this.state.error["proptError"]}</div>
                  </div>
                </Modal.Body>
                <div className="bookmark-popup-button-wrapper" style={{ width: '22%' }}>
                  <Button text="Cancel" customColor="#000000" action={() => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }} />
                  <Button text="Share" customColor="#EB1700" action={this.handleSubmit} />
                </div>
              </div>
            </div>
            {alertMessageShowModal && <AlertMessagePopUpModal 
              color={alertMessageModelColor} 
              content={alertMessageContent} 
              showModal={alertMessageShowModal} 
              handleClose={() => this.closeAlertMessage()} />
            }
            {isLoading && <div
              style={{ 
                //border: '1px solid', 
                position: 'absolute', 
                textAlign: "center", 
                padding: "10%",
                width: '100%' 
              }}
            >
              <img
                src={imsLoader}
                alt="Loading Data"
                style={{ width: "10%" }}
              />
            </div>}
          </Modal>             
    );
  }
}

export default SharePubMedModal;